import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ReactModal from 'react-modal';
import { FormProvider, useForm } from 'react-hook-form';
import { joiResolver } from '@hookform/resolvers/joi';
import { HTextarea } from '../../../validation/HForm';
import { messageModalScheme } from '../../../validation/scheme/messageModalScheme';
import { openWriteMessageModal, requestForSendMessage, resetClientList } from '../../../redux/actions/notificationAction';
import { ConfirmModal } from '../../common';
import { Message } from '../../utilites';

const WriteMessageModal = () => {

  const { clients, showWriteMessageModal, commonError, messageSentSuccess } = useSelector(({ notification }) => notification);
  const [isMessage, setIsMessage] = useState(false);
  const [countOfSymbols, setCountOfSymbols] = useState(0);
  const dispatch = useDispatch();

  useEffect(() => {
    if ( messageSentSuccess === true ) {
      dispatch(openWriteMessageModal(false))
      dispatch(resetClientList())
      setCountOfSymbols(0)
    }
  }, [dispatch, commonError, messageSentSuccess]);

  const form = useForm({
    mode: 'onChange',
    resolver: joiResolver(messageModalScheme),
  });

  const onWriteMessageSubmit = () => {
    setIsMessage(true)
  }

  const countSymbols = () => {
    const {message} = form.getValues()
    setCountOfSymbols(message.length)
  }

  const closeWriteMessageModal = () => {
    dispatch(openWriteMessageModal(false))
  }

  const submitConfirmModal = useCallback(() => {

    const { message } = form.getValues()
    const payload = {
        clientIds: clients.map(i => +i.id),
        textMessage: message,
        type: 'STANDARD',
    }

    dispatch(requestForSendMessage(payload))
    setIsMessage(false)

  }, [clients, dispatch, form]);

  const handleCloseConfirmModal = useCallback(() => {
    setIsMessage(false)
  }, []);

  return (
    <>
      <ReactModal
        isOpen={showWriteMessageModal}
        contentLabel="Modal"
        className="modal-container overflow-auto"
        overlayClassName="modal-overlay"
      >
      <div>
        {commonError && <Message type="error" text={commonError} />}
        <div className="modal-header d-i p-b-0 text-center">
          <h2>Отправка сообщения</h2>
        </div>
        <div className="modal-body">
          <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(onWriteMessageSubmit)}>
              <div className="d-flex flex-space-between ">
                <label className="form-element-label" htmlFor="message">
                  Введите текст сообщения
                </label>
                <span className="form-element-label">{countOfSymbols} из 300</span>
              </div>
              <div className="form-element-data textarea">
                <HTextarea
                  h="true"
                  className="input"
                  rows="5"
                  cols="10"
                  name="message"
                  id="message"
                  onChange = {countSymbols}
                />
              </div>
              <div className="modal-footer modal-footer__spread-apart">
                <button className="button">Отправить</button>
                <button className="button-light" 
                    onClick={closeWriteMessageModal}
                >
                  Отменить
                </button>
              </div>
            </form>
          </FormProvider>
        </div>
      </div>
      </ReactModal>
      <ConfirmModal
          isOpen={isMessage}
          handleClose={() => handleCloseConfirmModal(false)}
          handleAction={submitConfirmModal}
          headerText="Отправка сообщения"
          bodyText="Вы хотите отправить СМС?"
      />
    </>
  );
};

export default WriteMessageModal;
